import { Category } from '../types'

export const categories: { [Id in Category]: string } = {
  zyuutenmieruka: 'ジュウテン',
  roadcell: 'ロードセル',
  zentyou: 'ゼンチョウ',
  // eslint-disable-next-line @typescript-eslint/camelcase
  roadcell_zentyou: 'ロードセル・ゼンチョウ',
}
